export const STRIEP_GATEWAY_EVENTS = {
    LOAD_STRIPE: "@STRIPE/LOAD",
    MAKE_PAYMENT: "@STRIPE/MAKE_PAYMENT",
};
